<template>
    <div class="ml-n14 mb-n5">
        <v-select v-bind="$attrs"
                  v-on="$listeners"
                  @change="updateValue"
                  v-model="inputValue"
                  clearable
                  filled
                  style="transform:scale(0.8);transform-origin:100% 0%;"
                  :rules="rules">
        </v-select>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                type: String,
                required: true
            },
            rules: {},
        },
        data: () => ({
        }),
        methods: {
            updateValue: function (e) {
                this.$emit("input", e.target.value);
            }
        },
        computed: {
            inputValue: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            },
        },
    };
</script>
